import { render, staticRenderFns } from "./FrontGrossAccrualBaseControl.vue?vue&type=template&id=12592642&scoped=true"
import script from "./FrontGrossAccrualBaseControl.vue?vue&type=script&lang=js"
export * from "./FrontGrossAccrualBaseControl.vue?vue&type=script&lang=js"
import "./FrontGrossAccrualBaseControl.vue?vue&type=style&index=0&id=12592642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12592642",
  null
  
)

export default component.exports